export const DetailsView = () => {
	return (
		<div
			className="flexCenter"
			style={{height: "100%"}}
		>
			Details View - Please switch UI to V5
		</div>
	); // Not supported in V4
};
